import React, { useEffect } from 'react';
import Footer from '../../components/Footer';
import siliconIndiaCertificate from '../../assets/Newsletter/Silicon India.png';
import './SiliconIndia.css';

const SiliconIndia = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'SiliconIndia Recognition — Vardaan Data Sciences';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="siliconindia-page">
      <header className="si-hero">
        <div className="si-container">
          <div className="si-hero-grid">
            <div>
              <div className="si-eyebrow">
                <span className="si-dot" />
                Announcement
                <span className="si-pipe">·</span>
                2026
              </div>

              <h1 className="si-hero-title">
                Honoured and Elated: Celebrating Our <em>SiliconIndia</em> Recognition
              </h1>

              <p className="si-hero-lede">
                Recognised as Startup of the Year in GRC &amp; Third Party Risk Management.
              </p>
            </div>

            <aside className="si-hero-aside" aria-label="SiliconIndia award certificate">
              <img
                src={siliconIndiaCertificate}
                alt="SiliconIndia Startup of the Year certificate"
                className="si-certificate"
              />
            </aside>
          </div>
        </div>
      </header>

      <section className="si-section">
        <div className="si-container">
          <div className="si-body">
            <p>
              We are truly elated to share that we have been recognized as “Startup of the Year – GRC &amp; Third Party Risk Management” by SiliconIndia Magazine. This recognition is a proud and joyful moment for our entire team, and we carry it with deep gratitude, renewed confidence, and a stronger sense of purpose.
            </p>

            <p>
              Our heartfelt thanks to the SiliconIndia team for this honour and for acknowledging the thought, effort, and innovation that go into our work. Awards like this are not just milestones; they are meaningful reminders that disciplined execution, customer trust, and a commitment to solving complex business challenges can create real impact.
            </p>

            <p>
              In the Governance, Risk, Compliance, and Third Party Risk Management space, businesses today need more than tools, they need practical methodologies, strong risk insight, and reliable partners who can help them navigate complexity with clarity. This award reinforces our belief that our approach, built on best practices and purposeful innovation, is moving in the right direction.
            </p>

            <p>
              This recognition belongs to every team member, customer, partner, and well-wisher who has been part of our journey. It inspires us to continue raising the bar, strengthening our solutions, and delivering greater value to organizations that place their trust in us.
            </p>

            <p>
              Thank you once again to SiliconIndia Magazine for this recognition. We receive this award with humility, happiness, and an unwavering commitment to keep building, improving, and contributing meaningfully to the GRC and Third Party Risk Management ecosystem.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SiliconIndia;
